import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { message, Upload } from "antd";
// Import Swiper styles
import { InboxOutlined } from "@ant-design/icons";

import "swiper/swiper-bundle.css";
// import 'swiper/modules/navigation/navigation.min.css';

const { Dragger } = Upload;

const ImageSwiper = ({ imgs, onFileChange, onFileRemove, fileList }) => {
  function beforeUpload(file, batchFileList) {
  const maxFiles = 5;
  const existingCount = fileList?.length || 0;
  const currentIndex = batchFileList?.indexOf(file) ?? 0;
  const totalAfterAdd = existingCount + currentIndex + 1;

  if (totalAfterAdd > maxFiles) {
    message.error(
      <span className="messageText">You can upload a maximum of 5 files.</span>,
    );
    return Upload.LIST_IGNORE;
  }

  const isPNG =
    file.type === "image/png" ||
    file.type === "image/jpg" ||
    file.type === "image/jpeg";

  const sum = file.size;
  if (sum > 7340032) {
    message.error(
      <span className="messageText">
        File size is more than 7 MB. Only 7 MB below files are accepted.
      </span>,
    );
    return Upload.LIST_IGNORE;
  }

  if (!isPNG) {
    message.error(
      <span className="messageText">
        Invalid file type. Allowed types are PNG or JPG.
      </span>,
    );
    return Upload.LIST_IGNORE;
  }

  return false;
}
  return (
    <div className="userDragger">
      <Dragger
        customRequest={(options) => {
          const { onSuccess, file } = options;
          onSuccess(null, file);
        }}
        name="logo"
        // maxCount={5}
        onChange={onFileChange}
        beforeUpload={beforeUpload}
        fileList={fileList}
        onRemove={onFileRemove}
        multiple
        accept={["image/png", "image/jpeg", "image/jpg"]}
      >
        <p className="flex-center">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Drag here to upload JPG/PNG
          <br />
          Or click here to attach
        </p>
        <p className="ant-upload-text">
          You can upload a maximum of 5 files, 7MB each.
        </p>
      </Dragger>
      <Swiper
        spaceBetween={50}
        modules={[Navigation]}
        slidesPerView={1}
        navigation
        className="mt2"
        // onSlideChange={() => console.log('slide change')}
        // onSwiper={(swiper) => console.log(swiper)}
      >
        {imgs?.map((ele, idx) => (
          <SwiperSlide key={"img" + idx}>
            <div className="image-preview">
              <img src={ele?.src} alt="" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSwiper;
